import './BestOfferWidget.scss';

type Swiper = import('swiper').default;

type HTMLElementWIthSwiper = HTMLElement & { swiper: Swiper };

/**
 *
 */
export class BestOfferWidget {
    /**
     * Type guard
     *
     * @param el
     * @returns
     */
    protected static isSwiper<T extends HTMLElementWIthSwiper>(
        el: HTMLElement | null
    ): el is T {
        return el?.hasOwnProperty('swiper') ? true : false;
    }
    /**
     * Табы
     */
    protected readonly controls!: NodeListOf<HTMLElement>;
    /**
     * Слайдер
     */
    protected readonly slider!: HTMLElement | null;
    /**
     * Спрятанные слайды
     */
    protected hidden!: NodeListOf<HTMLElement>;
    /**
     * Активная кнопка
     */
    protected activeButton!: HTMLElement;
    /**
     * Список ф-ций для отписки обработчиков событий
     */
    private listeners: Function[] = [];
    /**
     *
     *
     * @param el
     */
    constructor(protected readonly el: HTMLElement) {
        this.slider = el.querySelector<HTMLElement>('.swiper-container');

        this.controls = el.querySelectorAll<HTMLElement>(
            '.section-title__buttons > .btn'
        );

        this.hidden = el.querySelectorAll<HTMLElement>(
            '.best-offers-hidden > .swiper-slide'
        );

        this.activeButton = this.controls[0];

        this.listeners = this.createListeners();
    }
    /**
     * Навешивает обработчики кликов и возвращает список ф-ций для отписки
     *
     * @returns
     */
    protected createListeners() {
        return [...this.controls].map((button) => {
            const handler = (e: Event) => this.onControlClick(button);
            button.addEventListener('click', handler);
            return () => button.removeEventListener('click', handler);
        });
    }
    /**
     * Обработка клика на кнопку
     *
     * @param button
     * @param buttonIndex
     * @returns
     */
    protected onControlClick(button: HTMLElement) {
        if (button === this.activeButton) {
            return;
        }

        this.activeButton = button;

        this.controls.forEach((el) => {
            if (el === button) {
                el.classList.add('active');
            } else {
                el.classList.remove('active');
            }
        });

        if (BestOfferWidget.isSwiper(this.slider)) {
            const slidesSourceId = this.activeButton.getAttribute('data-flat-type');
            const slides =
                document.querySelectorAll(
                    `#flat-type-${slidesSourceId} > .swiper-slide`
                ) || [];

            const toSlider = [...slides]?.map(
                (e) => `<div class="swiper-slide">${e.innerHTML}</div>`
            );

            this.slider.swiper.removeAllSlides();
            this.slider.swiper.appendSlide(toSlider);
        }
    }
    /**
     * Отписываемся от событий
     */
    public destroy() {
        this.listeners.forEach((fn) => fn());
    }
}
